/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as React from 'react';
import { IEveIframeViewProps } from './eve-iframe';

export default (props: IEveIframeViewProps) => {
    return (
        <iframe
            //@ts-ignore
            style={{ width: '100%', height: `${props.config.height}px`, border: 'none', overflow: 'auto' }}
            src={props.config.srcURL}
        ></iframe>
    );
};
